var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.016 15.29a14.938 14.938 0 0 0 3.412 10.246l8.301-21.958L1.015 15.29zm5.515 12.336a14.938 14.938 0 0 0 9.47 3.366 14.94 14.94 0 0 0 9.644-3.51l-9.555-9.556-9.559 9.7zm20.96-1.99A14.94 14.94 0 0 0 31 15.992a14.94 14.94 0 0 0-3.507-9.64l-9.573 9.715 9.57 9.57zm-1.841-21.13L8.64 21.768 16.492 1a14.935 14.935 0 0 1 9.156 3.507z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKlay);
export default __webpack_public_path__ + "static/media/KLAY.1abd37e578ee1c1cadd3e2e9d8cc20cc.svg";
export { ForwardRef as ReactComponent };